// 飞行模式
export default {
    'FM1': 'Not flying',
    'FM2': 'Take Off',
    'FM3': 'Land',
    'FM4': 'Return',
    'FM5': 'Return Home',
    'FM6': 'Homing',
    'FM7': 'Direction',
    'FM8': 'Surround',
    'FM9': 'Stabilization',
    'FM10': 'Fixed Height',
    'FM11': 'Fixed Point',
    'FM12': 'Automatic Route',
    'FM13': 'AB point mode',
}